const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CargoQuery: any = {
    CompanyList: Backofficebff + '/v1/cargo/companylist',
    CompanyListV2: Backofficebff + '/v1/cargo/companylist-v2',
    GetSelectedItemList: Backofficebff + '/v1/foreign/cargocompany/selectboxitemlist',
    GetShippingCompanyLabel: Backofficebff + '/v1/cargo/get-shipping-company-label',
    GetShippingCompanyForFastCargo: Backofficebff + '/v1/cargo/get-shipping-company-for-fast-cargo',
    GetFastCargoManagement: Backofficebff + '/v1/cargo/get-fast-cargo-management',
};
